<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Dente supranumerário"
    >
        <rkm-form
            ref="RkmForm"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-input
                        :validations="validations.local"
                        label="Local"
                        v-model="model.local"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-area
                no-margin-top
                title="Procedimentos"
            >
                <template slot="trailing">
                    <rkm-button
                        @click="$refs.ModalProcedimento.open()"
                        color="primary"
                        small
                        title="Adicionar"
                    >
                        <rkm-icon icon="plus" />
                    </rkm-button>
                </template>

                <ProcedimentoClinicoList
                    :data="{form: data.form, model}"
                    @edit="$refs.ModalProcedimento.open($event)"
                />
            </rkm-area>

            <rkm-row class="mt-2">
                <rkm-col cols="12">
                    <rkm-form-textarea
                        :validations="validations.observacao"
                        label="Observações"
                        rows="6"
                        v-model="model.observacao"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <ProcedimentoClinicoModal
            :data="{form: data.form, model}"
            ref="ModalProcedimento"
        />

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="save"
                color="primary"
            >
                {{item ? 'Salvar' : 'Incluir'}}
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import ProcedimentoClinicoList from '@/components/ambulatorio/acolhimento-saude-bucal/components/procedimento-clinico/List'
import ProcedimentoClinicoModal from '@/components/ambulatorio/acolhimento-saude-bucal/components/procedimento-clinico/Modal'

// Mixins.
import {object} from '@/mixins'

export default {
    components: {ProcedimentoClinicoList, ProcedimentoClinicoModal},
    computed: {
        validations() {
            return {
                local: {required: true, max: 100},
                observacao: {max: 5000},
            }
        },
    },
    data: () => ({
        item: null,
        model: {
            local: null,
            procedimentosClinicos: [],
            observacao: null,
        },
    }),
    methods: {
        open(item = null) {
            this.item = item

            if (this.item) {
                this.edit()
            } else {
                this.create()
            }

            this.$refs.RkmModal.show()
        },
        create() {
            this.resetForm()
        },
        edit() {
            this.model = this.clone({
                local: this.item.local,
                procedimentosClinicos: this.item.procedimentosClinicos,
                observacao: this.item.observacao,
            })
        },
        store() {
            this.getDentesSupranumerarios().push(this.prepareData())
        },
        update() {
            Object.assign(this.item, this.prepareData())
        },
        prepareData() {
            return {
                local: this.model.local,
                procedimentosClinicos: this.model.procedimentosClinicos,
                observacao: this.model.observacao,
            }
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    if (this.model.procedimentosClinicos.length === 0) {
                        this.showValidationNotification('É necessário incluir ao menos um procedimento.')
                        return
                    }

                    if (this.item) {
                        this.update()
                    } else {
                        this.store()
                    }

                    this.$refs.RkmModal.hide()
                })
        },
        resetForm() {
            this.model.local = null
            this.model.procedimentosClinicos = []
            this.model.observacao = null
        },
        getDentesSupranumerarios() {
            return this.data.model.odontograma.dentesSupranumerarios
        },
    },
    mixins: [object],
    props: {
        data: {required: true, type: Object},
    },
}
</script>
